module.exports = __webpack_public_path__ + "static/media/quality_zh.39ee1d35.png";